import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Teams from '../views/Teams.vue'
import Results from '../views/Results.vue'
import Sponsors from '../views/Sponsors.vue'
import Admin from '../views/Admin.vue'
import Rules from '../views/Rules.vue'
import Schedule from '../views/Schedule.vue'
import Documents from '../views/Documents.vue'
import Gallery from '../views/Gallery.vue'
import DisciplinaryCommitteeView from '../views/DisciplinaryCommittee.vue'
import FreeAgent from '../views/FreeAgent.vue'
import TeamUpload from '../views/TeamUpload.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/teams',
    name: 'Teams',
    component: Teams
  },
  {
    path: '/results',
    name: 'Results',
    component: Results
  },
  {
    path: '/sponsors',
    name: 'Sponsors',
    component: Sponsors
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/rules',
    name: 'Rules',
    component: Rules
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery
  },
  {
    path: '/dk',
    name: 'dk',
    component: DisciplinaryCommitteeView
  },
  {
    path: '/free-agents',
    name: 'FreeAgents',
    component: FreeAgent
  },
  {
    path: '/team-upload',
    name: 'TeamUpload',
    component: TeamUpload
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 